import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { X, Clock } from "lucide-react";
import { useBusinessStatus } from "@/context/BusinessStatusContext";

export default function SiteStatusBar() {
  const { status } = useBusinessStatus();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(false);

  if (pathname === "/admin") return null;
  if (!status || status.status === "open") return null;
  if (dismissed) return null;

  const soon = status.status === "closing_soon";
  const tone = soon
    ? "bg-amber-500 text-[#0A2818] border-amber-300"
    : "bg-red-600 text-white border-red-400";
  const label = soon ? "CLOSING SOON" : "WE'RE CLOSED";

  return (
    <div data-testid="site-status-bar" className={`w-full border-b ${tone}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-2 flex items-center justify-center gap-3 text-sm font-semibold relative">
        <Clock className="w-4 h-4 shrink-0" />
        <span className="text-center">
          <span className="font-display font-black uppercase tracking-wide">{label}</span>
          <span className="mx-2 opacity-70">·</span>
          <span>{status.message}</span>
          {status.status === "closed" && (
            <button data-testid="site-status-bar-preorder" onClick={() => navigate("/menu")} className="ml-3 underline underline-offset-2 font-bold hover:opacity-80">Pre-Order Now</button>
          )}
        </span>
        <button data-testid="site-status-bar-dismiss" onClick={() => setDismissed(true)} className="absolute right-2 top-1/2 -translate-y-1/2 opacity-70 hover:opacity-100" aria-label="Dismiss">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
